// src/hooks/useAnalyses.js
import { useState, useEffect } from 'react';
import { apiService } from '../services/api';

export const useAnalyses = (type = 'history') => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);

      let endpoint;
      switch (type) {
        case 'history':
          endpoint = '/files/personal-history';
          break;
        case 'bookmarks':
          endpoint = '/files/bookmarks';
          break;
        default:
          endpoint = '/files/personal-history';
      }

      const response = await apiService.get(endpoint);
      setData(response);
    } catch (err) {
      console.error('Error fetching analyses:', err);
      setError(err.message || 'Failed to fetch analyses');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [type]);

  return { 
    data, 
    loading, 
    error, 
    refetch: fetchData 
  };
};